export default __webpack_public_path__ + "static/media/vision.95745dff.png";